<template>
  <svg
    width="16px"
    height="12px"
    viewBox="0 0 16 12"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g id="11-Code" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g
        id="D_02.2_Online-Code"
        transform="translate(-734.000000, -534.000000)"
        fill="currentColor"
      >
        <g id="online-code">
          <g id="latest-code" transform="translate(495.000000, 374.000000)">
            <g id="copy-code" transform="translate(0.000000, 136.000000)">
              <g
                id="Actions-/-Formatting-/-link-/-24"
                transform="translate(239.000000, 22.000000)"
              >
                <path
                  d="M14.625,3.38 C14.0620944,2.81513644 13.2974544,2.49763429 12.5,2.49763429 C11.7025456,2.49763429 10.9379056,2.81513644 10.375,3.38 L11.085,4.09 C11.591424,3.58357601 12.329553,3.38579493 13.021341,3.57115897 C13.713129,3.756523 14.253477,4.29687096 14.438841,4.98865898 C14.6242051,5.680447 14.426424,6.41857603 13.92,6.925 L9.92,10.925 C9.41446919,11.431424 8.67716548,11.6296815 7.98582405,11.445091 C7.29448262,11.2605005 6.75413468,10.7211055 6.56832405,10.030091 C6.38251343,9.3390765 6.57946919,8.60142397 7.085,8.095 L7.79,7.385 L7.085,6.675 L6.375,7.385 C5.81013644,7.94790562 5.49263429,8.71254557 5.49263429,9.51 C5.49263429,10.3074544 5.81013644,11.0720944 6.375,11.635 C6.94074544,12.1934988 7.70503612,12.5046101 8.5,12.5000505 C9.30057742,12.5032917 10.0692606,12.1864574 10.635,11.62 L14.635,7.62 C15.8020557,6.44597271 15.7975805,4.54850928 14.625,3.38 L14.625,3.38 Z M2.095,12.41 C1.71791269,12.0346633 1.50591947,11.5245456 1.50591947,10.9925 C1.50591947,10.4604544 1.71791269,9.95033674 2.095,9.575 L6.095,5.575 C6.47033674,5.19791269 6.98045442,4.98591947 7.5125,4.98591947 C8.04454558,4.98591947 8.55466326,5.19791269 8.93,5.575 C9.30482524,5.9534137 9.51045021,6.46747612 9.5,7 C9.50308154,7.53405474 9.29243879,8.04715887 8.915,8.425 L7.855,9.5 L8.565,10.21 L9.625,9.15 C10.7999858,7.97501419 10.7999858,6.06998582 9.62499997,4.89500003 C8.45001418,3.72001424 6.54498581,3.72001422 5.37,4.895 L1.37,8.895 C0.80360084,9.45810396 0.485122632,10.2238173 0.485122632,11.0225 C0.485122632,11.8211827 0.80360084,12.586896 1.37,13.15 C1.9394109,13.7042399 2.7054486,14.0099357 3.5,14 C4.30155123,14.0007653 5.07085912,13.6844144 5.64,13.12 L4.93,12.41 C4.55466326,12.7870873 4.04454558,12.9990805 3.5125,12.9990805 C2.98045442,12.9990805 2.47033674,12.7870873 2.095,12.41 L2.095,12.41 Z"
                  id="Fill"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'Link'
};
</script>
